import { useState } from 'react';
interface Props { variant?:'burgundy'|'cream'; compact?:boolean }
export function BrandLogo({variant='burgundy',compact=false}:Props){
 const [failed,setFailed]=useState(false); const src=`/images/brand/logo-${variant}.png`;
 return <span className={`brand brand--${variant}`} aria-label="Agustina Canina">{!failed&&<img src={src} alt="" onError={()=>setFailed(true)}/>} {failed&&<span className="brand__placeholder" aria-hidden="true">AC</span>}{!compact&&<span>Agustina<br/><strong>Canina</strong></span>}</span>;
}
